<div
  (chartInit)="myChart = $event" [initOpts]="{width: 200,height: 200}"
  [options]="option" echarts>
</div>